import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';

import { extractQueryParameters } from 'helpers/RoutesHelpers';
import {
    initCMPApp,
    openModal,
} from './reduxModules/ConsentManagementPlatform';

import { getBrowserPathnameSelector } from '../commons/selectors/RouterSelector';


import CMPModal from './components/CMPModal';
import CMPBanner from './components/CMPBanner';

const propTypes = {
    AppActions: PropTypes.shape({
        initCMPApp: PropTypes.func.isRequired,
        openModal: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    browserPathname: PropTypes.string.isRequired,
};

class CMPModalPortal extends Component {

    constructor(props) {
        super(props);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.element = document.createElement('div');
        this.appSelector = '#js-app-authentication';
        this.portalRoot = document.querySelector(this.appSelector);
    }

    componentDidMount() {
        const { AppActions, browserPathname } = this.props;
        AppActions.initCMPApp(browserPathname);
        this.portalRoot.appendChild(this.element);
    }

    componentWillUnmount() {
        this.portalRoot.removeChild(this.element);
    }

    onOpenModal() {
        const { AppActions } = this.props;
        AppActions.openModal();
    }

    renderPortalContent() {
        const { history } = this.props;
        const CMPModalLocation = {
            pathname: '',
            search: '',
            hash: '',
        };
        if (history && history.location) {
            CMPModalLocation.pathname = extractQueryParameters(history.location.search)['cmp-modal'] || '';
        }
        return (
            <>
                <CMPModal location={CMPModalLocation} />
                <CMPBanner />
            </>
        );
    }

    render() {
        return ReactDOM.createPortal(
            this.renderPortalContent(),
            this.element,
        );
    }

}

CMPModalPortal.propTypes = propTypes;

function mapStateToProps(state) {
    return {
        browserPathname: getBrowserPathnameSelector(state),
    };
}

const ConnectedApp = withRouter(
    connect(mapStateToProps, (dispatch) => ({
        AppActions: bindActionCreators({
            initCMPApp,
            openModal,
        }, dispatch),
    }))(CMPModalPortal),
);

export default ConnectedApp;
